Namespace 'Monitoring.Reports.Publications.Content'

class Monitoring.Reports.Publications.Content.TargetingView extends Backbone.View

  className: 'content-section content-targeting'
  template: JST['backbone/templates/monitoring/reports/publications/content/targeting']

  initialize: (@options = {}) ->
    # just set @options

  render: ->
    content = @options.contents[0]
    params =
      provider: 'facebook'
      type: 'post'
      content_id: content.content_id
    $.ajax
      type: 'post'
      url: '/monitoring/reports/publications/targeting'
      data: params
      success: @renderResults
      error: @fail

  renderResults: (targeting) =>
    @$el.addClass('rendered')
    @$el.html(@template({ targeting }))
    @trigger('rendered')

  fail: =>

    @trigger('fail')
